export const CRED_ELIGIBLITY_TIMEOUT_E2 = 1000 * 8;
